// Default magazine size (rounds) suggested from a calibre string. Per-weapon value
// always wins; this is just a helpful starting point users can override.
const MAG_DEFAULTS = [
  [/5\.?56|5\.45/, 30],
  [/7\.?62\s*x?\s*39/, 30],
  [/7\.?62\s*x?\s*51|7\.?62\s*nato|\.308/, 20],
  [/saw|minimi|belt|lmg|gpmg|linked/, 200],
  [/9\s*mm|9\s*x\s*19|parabellum|luger/, 17],
  [/\.45|acp/, 7],
  [/\.40|s&w/, 15],
  [/12\s*(ga|gauge|bore)/, 8],
  [/\.50|12\.7/, 100],
  [/\.338|8\.6/, 5],
];

export function defaultMagSize(calibre) {
  const c = (calibre || "").toLowerCase().trim();
  if (!c) return "";
  for (const [re, n] of MAG_DEFAULTS) if (re.test(c)) return n;
  return "";
}
